module.exports = __webpack_public_path__ + "31cf28d1ccea2afbcb21182f2873a718.MP3";